import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { createBrowserHistory } from 'history'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web and AsyncStorage for react-native

import { combinedReducers, initialState } from '../reducers'

const persistConfig = {
  key: 'terminalPlanner',
  storage,
  whitelist: ['login', 'ui']
}

const persistedReducer = persistReducer(persistConfig, combinedReducers)

const history = createBrowserHistory()

const store = createStore(
  // @ts-ignore
  connectRouter(history)(persistedReducer),
  initialState,
  compose(applyMiddleware(routerMiddleware(history), thunk))
)

export default () => {
  const persistor = persistStore(store)
  return { store, persistor }
}
